import * as angular from 'angular';
import { upgradeExternalNg1Dependency } from '../common/ng1-upgrade-factory';

export const $qToken = upgradeExternalNg1Dependency<angular.IQService>('$q');
